import { render } from "./RecordView.vue?vue&type=template&id=bda29d64&scoped=true"
import script from "./RecordView.vue?vue&type=script&lang=js"
export * from "./RecordView.vue?vue&type=script&lang=js"

import "./RecordView.vue?vue&type=style&index=0&id=bda29d64&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bda29d64"]])

export default __exports__